import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { clearVeyaTeamToken } from "../../lib/api";
import { useSession } from "../../hooks/useSession";

export default function VeyaTeamShell() {
  const navigate = useNavigate();
  const { refreshSession } = useSession();

  async function handleLogout() {
    clearVeyaTeamToken();
    await refreshSession();
    navigate("/veya-team/login", { replace: true });
  }

    function tabClass({ isActive }) {
    return `avatar-folder-tab${isActive ? " is-active" : ""}`;
    }

  return (
    <section className="public-section">
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: 16,
          alignItems: "flex-start",
          marginBottom: 18,
        }}
      >
        <div>
          <div className="merchant-eyebrow-lite">Veya Team</div>
          <h1 className="public-h1" style={{ marginBottom: 6 }}>
            Internal tools
          </h1>
          <p className="public-lede" style={{ maxWidth: 680 }}>
            Editorial controls and lightweight debugging access for Veya.
          </p>
        </div>

        <button type="button" className="gold-btn" onClick={handleLogout}>
          Log out
        </button>
      </div>

      {/* Tabs */}
      <div
        style={{
          display: "flex",
          gap: 6,
          paddingBottom: 6,
          borderBottom: "1px solid rgba(176,140,108,0.22)",
          marginBottom: 20,
          overflow: "visible", // prevents clipping
        }}
      >
        <NavLink to="/veya-team/edits" className={tabClass}>
          Edits
        </NavLink>

        <NavLink to="/veya-team/merchants" className={tabClass}>
          Merchants
        </NavLink>

        <NavLink to="/veya-team/activity" className={tabClass}>
          Activity / Debug
        </NavLink>
      </div>

      {/* Content */}
      <div style={{ overflow: "visible" }}>
        <Outlet />
      </div>
    </section>
  );
}